import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import Link from "next/link";
import { memo, useMemo } from "react";
import { PublicSignUpButton } from "~/components/PublicSignUpButton";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { Routes } from "~/constants/routes";
import { PUBLIC_TOP_BAR, PUBLIC_TOP_BAR_LOGO } from "~/constants/testIDs";
import { useLaunchDarklyFlags } from "~/hooks/useLaunchDarklyFlags";
export const PUBLIC_TOP_BAR_HEIGHT = 56;
export const PublicTopBar = /*#__PURE__*/ memo((param)=>{
    let { workspaceInfo, accountInfo } = param;
    const { workspaceId } = usePublicWorkspace();
    const { hideShortUrlSignUpButton, whiteLabelWorkspaces } = useLaunchDarklyFlags();
    const shouldHideLogo = useMemo(()=>{
        return whiteLabelWorkspaces === null || whiteLabelWorkspaces === void 0 ? void 0 : whiteLabelWorkspaces.includes(workspaceId);
    }, [
        whiteLabelWorkspaces,
        workspaceId
    ]);
    const shouldHideSignUpButton = useMemo(()=>{
        return hideShortUrlSignUpButton === null || hideShortUrlSignUpButton === void 0 ? void 0 : hideShortUrlSignUpButton.includes(workspaceId);
    }, [
        hideShortUrlSignUpButton,
        workspaceId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex h-14 items-center justify-between bg-grey-3 px-3",
        "data-testid": PUBLIC_TOP_BAR,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: workspaceInfo
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-4",
                children: [
                    accountInfo ? accountInfo : !shouldHideSignUpButton ? /*#__PURE__*/ _jsx(PublicSignUpButton, {}) : undefined,
                    !shouldHideLogo && /*#__PURE__*/ _jsx(Link, {
                        href: Routes.root,
                        children: /*#__PURE__*/ _jsx(Air, {
                            className: "w-[48px] text-blue-9",
                            "data-testid": PUBLIC_TOP_BAR_LOGO
                        })
                    })
                ]
            })
        ]
    });
});
PublicTopBar.displayName = "PublicTopBar";
